import type { ProcessOptions, ProcessResult } from '../types';

let currentWorker: Worker | null = null;

export async function processImage(file: File, options: ProcessOptions): Promise<ProcessResult> {
  if (!('Worker' in window) || !('OffscreenCanvas' in window)) {
    throw new Error('当前浏览器版本较旧，请使用最新版 Safari、Chrome 或 Edge');
  }
  currentWorker?.terminate();
  const worker = new Worker(new URL('../workers/bead.worker.ts', import.meta.url), { type: 'module' });
  currentWorker = worker;
  const buffer = await file.arrayBuffer();

  return new Promise((resolve, reject) => {
    const finish = () => {
      worker.terminate();
      if (currentWorker === worker) currentWorker = null;
    };
    worker.onmessage = (event) => {
      const message = event.data;
      if (message.type === 'error') {
        finish();
        reject(new Error(message.message || '图片处理失败'));
        return;
      }
      finish();
      resolve({
        width: message.width,
        height: message.height,
        colorIndices: new Uint16Array(message.colorIndices),
        empty: new Uint8Array(message.empty),
        elapsedMs: message.elapsedMs,
        warning: message.warning || undefined
      });
    };
    worker.onerror = (event) => {
      finish();
      reject(new Error(event.message || '图片处理线程启动失败'));
    };
    worker.postMessage({ type: 'process', buffer, mime: file.type, options }, [buffer]);
  });
}

export function cancelProcessing() {
  currentWorker?.terminate();
  currentWorker = null;
}
